import type { RecommendationType } from '../common/types.tsx';
import { jpdRecommendation } from './jpd-recommendation/index.tsx';

const createRecommendationsList = () => {
	const recommendationsList: RecommendationType[] = [];

	recommendationsList.push(jpdRecommendation);

	// Add your own templates

	return recommendationsList;
};

export const recommendationsList: Array<RecommendationType> = createRecommendationsList();
